<p style="text-align: center; color: red;">{{ viewData }}</p>
<p style="text-align: center;"><br><button mat-button class="md-button" (click)="closeModal()">okay</button></p>
